module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-14.0c9dc9bc.png";